// extracted by mini-css-extract-plugin
export var dropdownButton = "_2e-0";
export var fullWidthDropdownButton = "_2e-1";
export var icon = "_2e-3";
export var iconPlaceholder = "_2e-2";
export var menuItemRow = "_2e-9";
export var separator = "_2e-e";
export var shortcutContainer = "_2e-7";
export var shortcutContainerFilled = "_2e-8";
export var shortcutIconLg = "_2e-6";
export var shortcutIconMd = "_2e-5";
export var shortcutIconSm = "_2e-4";
export var submenuChevron = "_2e-d";
export var submenuDropdown = "_2e-a";
export var submenuTriggerRow = "_2e-b";
export var submenuTriggerRowOpen = "_2e-c";